
import { Button } from "element-ui"
import Dialog from "@/components/auth/Modal.vue"
import authContent from "@/components/auth/authContent.vue"
import CreatePassword from "@/components/auth/CreatePassword.vue"
import { AUTH_TYPE, AUTH_ERROR_CODE } from "@/constants/auth"
import { closeAPPAndSMSNotification } from "@/api/notification"
import { signUp } from "@/api/authentication"
import { getDomain } from "@/utils/utils"

export default {
  components: {
    authContent,
    CreatePassword,
    Dialog,
    [Button.name]: Button
  },

  data() {
    return {
      authContentType: AUTH_TYPE.SIGN_UP,
      haveAccountModal: false,
      showCreatePasswordModal: false
    }
  },
  head() {
    return {
      title: `${this.$t("pageTitle.signUp")}`
    }
  },
  methods: {
    handleClose() {
      this.haveAccountModal = false
    },
    handleGoToLogin() {
      this.$navigation.push({
        path: "/auth/login"
      })
    },
    async handleSignUp(value) {
      try {
        const res = await signUp({
          phone: value.phoneNumber,
          authCode: value.code,
          domain: getDomain(),
          loginChannel: 3,
          venderId: this.$commonParams.comm.venderId
        })
        this.$message.success(this.$t("common.signUpSuccess"))
        if (!value.notificationChecked) {
          await closeAPPAndSMSNotification(res.data?.phone)
        }
        window.location.replace("/")
      } catch (error) {
        if (error.code === AUTH_ERROR_CODE.MOBILE_ALREADY_REGISTER) {
          this.haveAccountModal = true
        } else {
          this.$message.error(error.result)
        }
        console.error(error)
      }
    }
  }
}
